import React, { useState, useRef, useEffect } from 'react';

export default function MultiSelectFilter({ label, options, selected, onChange, searchable = false, placeholder = 'All', renderOption }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    function handler(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const filteredOptions = searchable && search
    ? options.filter(o => o.toLowerCase().includes(search.toLowerCase()))
    : options;

  function toggle(val) {
    if (selected.includes(val)) {
      onChange(selected.filter(v => v !== val));
    } else {
      onChange([...selected, val]);
    }
  }

  const displayText = selected.length === 0 ? placeholder : selected.length <= 2 ? selected.join(', ') : `${selected.length} selected`;

  return (
    <div className="multi-filter" ref={ref}>
      <label className="multi-filter-label">{label}</label>
      <button className={`multi-filter-btn ${selected.length > 0 ? 'active' : ''}`} onClick={() => setOpen(!open)}>
        <span className="multi-filter-text">{displayText}</span>
        <span className="multi-filter-arrow">{open ? '▴' : '▾'}</span>
      </button>
      {open && (
        <div className="multi-filter-dropdown">
          {searchable && (
            <input autoFocus className="multi-filter-search" value={search} onChange={e => setSearch(e.target.value)} placeholder="Search..." onClick={e => e.stopPropagation()} />
          )}
          <div className="multi-filter-options">
            {filteredOptions.length === 0 && <div className="multi-filter-empty">No matches</div>}
            {filteredOptions.map(opt => (
              <label key={opt} className={`multi-filter-option ${selected.includes(opt) ? 'checked' : ''}`}>
                <input type="checkbox" checked={selected.includes(opt)} onChange={() => toggle(opt)} />
                <span>{renderOption ? renderOption(opt) : opt}</span>
              </label>
            ))}
          </div>
          {selected.length > 0 && (
            <button className="multi-filter-clear" onClick={() => { onChange([]); }}>Clear All</button>
          )}
        </div>
      )}
    </div>
  );
}
